import { render, staticRenderFns } from "./PurchasePrices.vue?vue&type=template&id=c96f676a"
import script from "./PurchasePrices.vue?vue&type=script&lang=js"
export * from "./PurchasePrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports